<template>
  <modal :showModal="showModal" @close-modal="$emit('close-modal')" width="35">
    <div class="my-4">
      <div class="mb-4">
        <p class="flex">
          <span class="mt-1">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.6446 1.78239C19.3854 1.47607 19.0225 1.28896 18.6227 1.25556L4.53846 0.0795501C4.13854 0.0461518 3.74971 0.170487 3.44335 0.429588C3.13823 0.687673 2.95139 1.04873 2.91694 1.44665L2.63358 4.10508H1.50214C0.673865 4.10508 0 4.77894 0 5.60722V14.4237C0 15.252 0.673865 15.9258 1.50214 15.9258H15.6354C16.4637 15.9258 17.1376 15.252 17.1376 14.4237V12.9935L17.6391 13.0354C17.6814 13.0389 17.7235 13.0406 17.7652 13.0406C18.5374 13.0406 19.1957 12.4465 19.2611 11.6634L19.9947 2.87755C20.028 2.47767 19.9037 2.08876 19.6446 1.78239ZM16.3563 14.4237C16.3563 14.8212 16.0329 15.1446 15.6354 15.1446H1.50214C1.10464 15.1446 0.781247 14.8212 0.781247 14.4237V5.60722C0.781247 5.20972 1.10464 4.88633 1.50214 4.88633H15.6354C16.0329 4.88633 16.3563 5.20972 16.3563 5.60722V14.4237ZM19.2161 2.81251L18.4825 11.5984C18.4494 11.9945 18.1002 12.29 17.7041 12.2568L17.1376 12.2095V5.60722C17.1376 4.77894 16.4637 4.10508 15.6354 4.10508H3.41928L3.69424 1.5254C3.69456 1.52243 3.69483 1.51951 3.69506 1.5165C3.72815 1.12037 4.07721 0.824899 4.47346 0.858102L18.5577 2.03411C18.7496 2.05013 18.9238 2.13993 19.0481 2.28696C19.1725 2.43399 19.2322 2.62059 19.2161 2.81251Z"
                fill="#CBD0DB" />
            </svg>
          </span>
          <span class="pl-1">PAYMENT DUE</span>
        </p>
        <span>₦ {{ formatAmount(totalAmmount) }} </span>
      </div>
      <div>
        <p class="text-lg font-medium mb-4">
          Select Your Preferred Payment Gateway
        </p>
        <div class="payment-options">
          <div class="payment-option payment__paystack">
            <paystack :amount="Math.round(totalAmmount * 100)" :email="useremail" :paystackkey="paystackkey"
              :reference="reference()" :callback="receivePayment" :metadata="metadata" :close="close" :embed="false">
              <div class="option-check">
                <div class="checked-circle"></div>
              </div>
              <div class="pl-4 -mt-4">
                <img src="@/assets/images/booking-management/paystack.svg" alt="paystack logo" />
              </div>
            </paystack>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import paystack from "vue-paystack";
import { userId } from "../../../services/apiConfig";

export default {
  components: {
    paystack,
  },

  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    tipInfo: {
      type: Object
    },
    costEngine: { type: Object },
    transactionId:{}
  },
  data() {
    return {
      ammount: "100"
    }
  },
  computed: {
    getCreatedShipment() {
      return this.$store.getters.getCreatedBooking;
    },
    totalAmmountFirstMile() {
      return this.costEngine?.cost
        ? Number(this.costEngine?.cost?.toFixed(2))
        : 10;
    },
    totalAmmount() {
      const cost =  this.costEngine?.cost || this.costEngine?.totalCost || this.costEngine?.totalValue
      return Number(cost)
    },
    totalShippingCost() {
      return this.idD2Tinterstate ? this.totalAmmountFirstMile : this.totalAmmount
    },
    metadata() {
      return {
        userId: userId()
      }
    },
    paystackkey() {
      return this.$store.getters.getPaystackKey
    },
    shippingId() {
      return this.getCreatedShipment?.id;
    },
    paymentInformation() {
      return this.$store.getters.paymentInformation;
    },
    useremail() {
      return this.$store.getters.user.email;
    },
    idD2Tinterstate() {
      const shippingmethod = this.$store.getters.getNewBookingShippingMethod;
      const isInterstate = this.$store.getters.getIsInterState;
      return isInterstate && shippingmethod === "door-to-door"
    }
  },
  watch: {
    showModal() {
      console.log("transaction id", this.getCreatedShipment, this.costEngine)
      // code here
    },
    reference() {
      console.log("refrence", this.reference())
    }
  },
  methods: {
    formatAmount(number) {
      return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
    async updateTransactionStatus(ref) {
      try {
        await this.$_updateNewTransactions(this.transactionId, {
          transactionReference: ref,
          payment_type: "card",
          tip: Number(this.tipInfo?.tip),
          tipAmount: this.tipInfo?.tipAmount,
        })
        this.$store.dispatch('setSavedActiveTab', 4)
      } catch (error) {
        this.handleError(error)
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
    checkValue(event) {
      if (Number(event.target.value) < 10) {
        this.ammount = 10
      } else {
        this.ammount = event.target.value
      }
    },
    reference() {

      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      console.log(">>>>>>..", text)
      return text;
    },
    async receivePayment(response) {
      let status = "unpaid";

      if (response.status == "success") {
        status = "paid";
        try {
          await this.updateTransactionStatus(response.reference)
        } catch (error) {
          console.log("error occured in transaction", error)
        }
      } else {
        response
      }

      this.$emit("process-paystack", status);
      this.closeModal()
    },
    close: function () {
      this.$emit("process-paystack", "unpaid");
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-options {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.payment-option {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.payment__card {
  width: 40%;
  padding: 1rem;
  background: rgba(201, 201, 201, 0.158967);
  border-radius: 5px;
}

.payment__flutterwave,
.payment__paystack {
  border: 1px solid #c5d1e6;
  border-radius: 5px;
  // padding: 0 1.5rem;
  // margin: 0 1rem;
}

.option-check {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1px solid #000000;
}

.option-check.checked {
  display: flex;
  justify-content: center;
  align-items: center;

  .checked-circle {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: #000000;
  }
}
</style>